export default __webpack_public_path__ + "media/490dbfce6dbfa9d85bddfd947e6fb009df5daf3273e1904bd8eb1c6b35d4c77b.svg";